import { makeStyles } from '@material-ui/core/styles'
import { dark, light } from '@material-ui/core/esm/styles/createPalette'

const useStyles = makeStyles(
	theme => {
		const color = theme.palette.calcContrastColor(dark.text.secondary, theme.palette.background.default)
		const borderColor = theme.palette.calcContrastColor(
			theme.palette.text.secondary,
			theme.palette.background.default,
		)
		return {
			root: {
				alignItems: ({ justify }) => justify,
				display: 'flex',
				flexDirection: 'column',
				'& $notchedOutline': {
					borderColor,
					borderWidth: '2px !important',
				},
				'& $textarea': {
					padding: 10.5,
					lineHeight: 1.5,
					borderRadius: theme.spacing(1),
					color: ({ withBgImage }) => (withBgImage ? light.text.primary : color),
					'&:hover': {
						'& $notchedOutline': {
							borderColor,
						},
					},
				},

				'& $multiline': {
					padding: 0,
				},
			},
			fullWidth: {
				'& $content': {
					display: 'flex',
					width: '100%',
				},
				'& $row': {
					justifyContent: 'space-between',
				},
			},
			notchedOutline: {},
			textarea: {},
			multiline: {},
			content: {},
			row: {},
		}
	},
	{ name: 'Questions-AnswerTypes-Text' },
)

export default useStyles
